import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

const WorkNavbar = ({ isWorkPage }) => {
  const location = useLocation();

  // use localStorage to persist the isExpanded state across page reloads which will retrieve the last saved state from localStorage.
  const [isExpanded, setIsExpanded] = useState(
    () => JSON.parse(localStorage.getItem("isExpanded")) ?? true
  );

  const works = [
    {
      id: 1,
      name: "GreenPlatter iOS App",
      discription: "- iOS App Development",
      path: "GreenPlatterApp",
    },
    {
      id: 2,
      name: "GreenPlatter",
      discription: "- Website Design",
      path: "GreenPlatter",
    },
    {
      id: 3,
      name: "Health and Wellness Tracker",
      discription: "- Web-App Front-end Development",
      path: "HealthandWellnessTracker",
    },
  ];

  //  Automatically Expand Menu on the Big Menu Page
  useEffect(() => {
    if (isWorkPage) {
      // monitor changes to the isWorkPage prop.
      setIsExpanded(true); //Expand the menu (setIsExpanded(true)).
      localStorage.setItem("isExpanded", JSON.stringify(true)); //Save this state in localStorage (true).
    }
  }, [isWorkPage]);

  return (
    <ul className="p-4 space-y-2 pt-0 md:pt-[8rem] transition-all duration-500">
      {works.map((work) => (
        <li key={work.id} className="overflow-hidden">
          <Link
            to={`/work/${work.path}`}
            onClick={() => {
              setIsExpanded(false); // after clicking big menu, make it to small menu
              localStorage.setItem("isExpanded", JSON.stringify(false)); // store the status to localStorage --> small menu
            }}
            className={`block hover:text-pink text-lightBrown md:p-2 md:pl-[4rem] transition-all duration-500 ${
              // if isExpanded=true, big menu; if isExpanded=false, small menu
              isExpanded
                ? // Big menu
                  "text-xl font-bold md:text-6xl"
                : // Small menu
                  "hidden md:block md:font-bold md:text-lg"
            } 
            
            ${
              // in small menu, work title focused or not
              location.pathname === `/work/${work.path}`
                ? "underline text-pink text-xl font-extrabold"
                : "hover:text-pink"
            }`}
          >
            {work.name}
          </Link>

          {/*------------------------ description animation ------------------------*/}
          <p
            className={`md:transition-all md:duration-500 md:ease-in-out ${
              isExpanded
                ? "ml-8 md:ml-32 md:text-2xl md:opacity-100 scale-100"
                : "hidden md:block md:ml-24 md:text-sm"
            }`}
          >
            {work.discription}
          </p>
        </li>
      ))}
    </ul>
  );
};

export default WorkNavbar;
